import { Interface } from 'ethers'

import { useAccount } from 'wagmi'

import { useValueTokens } from '@/contexts/VaultTokensContext'
import TokenGGP from '@/contracts/TokenGGP'

const useTokenGGPContract = () => {
  const { currentToken } = useValueTokens()
  const { chain } = useAccount()
  const data = currentToken.tokenAddresses[0][chain?.id]
  const contractInterface = new Interface(TokenGGP)

  return {
    address: data,
    contractInterface,
    abi: TokenGGP,
  }
}

export default useTokenGGPContract
